import { CostCenterAPI } from "api";
import { useFetchCostCenter } from "hooks/useFetchCostCenter";
import React, { createContext, useContext, useEffect, useState } from "react";

// Create context
const FiscalYearContext = createContext();

// Create Provider component
export const FiscalYearContextProvider = ({ children }) => {
  const [costCenterId, setCostCenterId] = useState(null);
  // const { data, isLoading } = useFetchCostCenter();
  // const costCenters = data?.data?.data || [];

  const [isLoading, setIsLoading] = useState(false);
  const [costCenters, setCostCenters] = useState([]);
  // const { data, isLoading } = useFetchCostCenter();

  const fetchCostCenter = async () => {
    setIsLoading(true);
    const res = await CostCenterAPI.get();
    setCostCenters(res?.data?.data || []);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchCostCenter();
  }, []);

  // Set default cost center when data is available
  useEffect(() => {
    if (costCenters.length > 0 && !costCenterId) {
      setCostCenterId(costCenters[0].id);
    }
  }, [costCenters, costCenterId]);

  return (
    <FiscalYearContext.Provider
      value={{ costCenterId, setCostCenterId, costCenters, isLoading }}
    >
      {children}
    </FiscalYearContext.Provider>
  );
};

// Custom hook for using context
export const useFiscalYear = () => {
  const context = useContext(FiscalYearContext);
  if (!context) {
    throw new Error(
      "useFiscalYear must be used within a FiscalYearContextProvider"
    );
  }
  return context;
};
